import { Link, Stack, Typography } from "@mui/material";
import { ShAlert } from "shared/SharedStyles/ShFeedback";
import { ShGreenBtn, ShTextFieldV2 } from "shared/SharedStyles/ShInputs";
import { VerificationContainer, VerificationContent, VerificationIcon } from "./AppLogin.styled";
import { useAppDispatch } from "helpers/hooks";

interface VerificationUIProps {
    email: string;
    otpValue: string;
    otpErrorMsg: string;
    isOtpVerifying: boolean;
    onOtpChange: (value: string) => void;
    onVerify: () => void;
    onStartOver: () => void;
    onClearError: () => void;
}

export const VerificationUI = ({
    email,
    otpValue,
    otpErrorMsg,
    isOtpVerifying,
    onOtpChange,
    onVerify,
    onStartOver,
    onClearError
}: VerificationUIProps) => {
    const dispatch = useAppDispatch();

    return (
        <VerificationContainer>
            <VerificationIcon />
            
            <VerificationContent>
                <Typography variant="h6" align="center" gutterBottom>
                    Verify your email address
                </Typography>

                <Typography variant="body1" color="textSecondary" align="center">
                    We've sent a verification code to <strong>{email}</strong>.
                    Please enter the 6-digit code below to verify your email address.
                </Typography>

                {otpErrorMsg && (
                    <ShAlert
                        severity="error"
                        onClose={onClearError}
                        sx={{ width: '100%' }}
                    >
                        {otpErrorMsg}
                    </ShAlert>
                )}

                <ShTextFieldV2
                    fullWidth
                    size="small"
                    label="Enter Security Code"
                    value={otpValue}
                    onChange={(e) => {
                        const numericOnly = e.target.value.replace(/\D/g, "");
                        onOtpChange(numericOnly);
                    }}
                    inputProps={{
                        maxLength: 6,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                    }}
                />

                <ShGreenBtn
                    fullWidth
                    variant="contained"
                    disableElevation
                    disabled={otpValue.length !== 6 || isOtpVerifying}
                    onClick={onVerify}
                >
                    {isOtpVerifying ? "Verifying..." : "Verify Email"}
                </ShGreenBtn>

                <Typography variant="body2" color="textSecondary" align="center">
                    Before continuing, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.
                </Typography>

                <Stack direction="row" spacing={2}>
                    {/* <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            dispatch(getOTPVerification({ email }));
                        }}
                    >
                        Resend verification email
                    </Link> */}
                    <Link
                        component="button"
                        variant="body2"
                        onClick={onStartOver}
                    >
                        Start over
                    </Link>
                </Stack>
            </VerificationContent>
        </VerificationContainer>
    );
}; 